module.exports = __webpack_public_path__ + "img/weddings_11_V.ab0b778f.webp";